export const applicationActionTypes = {
  APPLICATION_SELECTION_MODE: 'APPLICATION_SELECTION_MODE',
  APPLICATION_VIEW_MODE: 'APPLICAITON_VIEW_MODE',
  APPLICATION_TOGGLE_HEADER_NAVIGATION: 'APPLICATION_TOGGLE_HEADER_NAVIGATION',
  APPLICATION_LEFT_NAVIGATION: 'APPLICATION_LEFT_NAVIGATION',
  APPLICATION_REMOTE_LOADING: 'APPLICATION_REMOTE_LOADING',
  AUTHORIZATION_TOKEN_DATA: 'AUTHORIZATION_TOKEN_DATA',
  APPLICATION_SCREEN_SIZE_UPDATE: 'APPLICATION_SCREEN_SIZE_UPDATE',
  USER_SUBSCRIPTION_EXPIRED: 'USER_SUBSCRIPTION_EXPIRED'
};


// WEBPACK FOOTER //
// ./src/settings/actions/application-action-types.js